import api from "@/services/api";
import { RegisterFranchiseAssociatePayload } from "@/types/franchise-associate/FranchiseAssociate";

class RegisterFranchiseAssociate {
  execute = async (payload: RegisterFranchiseAssociatePayload) => {
    const response = await api().post("/franchise-associates", payload);
    return response.data;
  };
}

export { RegisterFranchiseAssociate };
